"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ProductItemComponent.default;
  }
});

var _ProductItemComponent = _interopRequireDefault(require("./ProductItem-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }